import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  getAIModels: async () =>
    apiCall(`${config.baseAPIUrl}/ai/list`, {
      method: 'POST',
    }),
}
